const ACTIONS = {
    CREATE_REQUEST: "CREATE_QUOTATION_REQUEST",
    CREATE_SUCCESS: "CREATE_QUOTATION_SUCCESS",
    CREATE_FAIL: "CREATE_QUOTATION_FAIL",

    FETCH_REQUEST: "FETCH_QUOTATION_REQUEST",
    FETCH_SUCCESS: "FETCH_QUOTATION_SUCCESS",
    FETCH_FAIL: "FETCH_QUOTATION_FAIL",

    FETCH_ALL_REQUEST: "FETCH_ALL_QUOTATIONS_REQUEST",
    FETCH_ALL_SUCCESS: "FETCH_ALL_QUOTATIONS_SUCCESS",
    FETCH_ALL_FAIL: "FETCH_ALL_QUOTATIONS_FAIL",

    UPDATE_REQUEST: "UPDATE_QUOTATION_REQUEST",
    UPDATE_SUCCESS: "UPDATE_QUOTATION_SUCCESS",
    UPDATE_FAIL: "UPDATE_QUOTATION_FAIL",

    DELETE_REQUEST: "DELETE_QUOTATION_REQUEST",
    DELETE_SUCCESS: "DELETE_QUOTATION_SUCCESS",
    DELETE_FAIL: "DELETE_QUOTATION_FAIL",

};

export default ACTIONS;
